module.exports = __webpack_public_path__ + "img/home-setting-active-3.afd61212.png";